<template>
    <div class="m_container">
        <!-- 修改密码 -->
        <el-form
            ref="pForm"
            :model="pForm"
            :rules="pRules"
            class="login-form"
            auto-complete="on"
            label-position="left"
        >
            <h3 class="title">修改密码</h3>
            <el-form-item prop="old_password">
                <el-input
                    v-model="pForm.old_password"
                    :type="pwdType"
                    name="old_password"
                    auto-complete="off"
                    placeholder="请输入旧密码"
                >
                    <i slot="prefix" class="el-icon el-icon-lock" />
                    <i slot="suffix" class="el-icon el-icon-view" :class="{'el-icon-view-actived':!pwdType}" @click="showPwd" />
                </el-input>
            </el-form-item>

            <el-form-item prop="new_password">
                <el-input
                    v-model="pForm.new_password"
                    :type="pwdType"
                    name="new_password"
                    auto-complete="off"
                    placeholder="请输入新密码"
                >
                    <i slot="prefix" class="el-icon el-icon-lock" />
                    <i slot="suffix" class="el-icon el-icon-view" :class="{'el-icon-view-actived':!pwdType}" @click="showPwd" />
                </el-input>
            </el-form-item>

            <el-form-item prop="new_password_confirmation">
                <el-input
                    v-model="pForm.new_password_confirmation"
                    :type="pwdType"
                    name="new_password_confirmation"
                    auto-complete="off"
                    placeholder="请输入确认密码"
                >
                    <i slot="prefix" class="el-icon el-icon-lock" />
                    <i slot="suffix" class="el-icon el-icon-view" :class="{'el-icon-view-actived':!pwdType}" @click="showPwd" />
                </el-input>
            </el-form-item>

            <el-form-item>
                <el-button
                    :loading="loading"
                    size="medium"
                    type="primary"
                    style="width:100%;"
                    @click.native.prevent="submit"
                >修改密码</el-button>
            </el-form-item>
        </el-form>
        <div class="textWrap">
            <p class="register" @click="hancleChangeType('register')">注册账号</p>
            <p>|</p>
            <p class="register" @click="hancleChangeType('login')">立即登录</p>
            <p>|</p>
            <p class="register" @click="hancleChangeType('reset')">重置密码</p>
        </div>
    </div>
</template>

<script>
const defaultSettings = require('../../../settings')

export default {
    name: 'EditPassword',
    components: { },
    data() {
        const validatePass = (rule, value, callback) => {
            if (value.length < 6 || value.length > 16) {
                callback(new Error('密码长度需6-16位'))
            } else {
                callback()
            }
        }

        const pwdAgainCheck_p = (rule, value, callback) => {
            if (value.length < 6 || value.length > 16) {
                callback(new Error('密码长度需6-16位'))
            } else if (this.pForm.new_password !== this.pForm.new_password_confirmation) {
                callback(new Error('两次输入密码不一致！'))
            } else {
                callback()
            }
        }
        return {
            pageTitle: defaultSettings.title,
            loading: false,
            pwdType: 'password',
            pForm: {
                old_password: '',
                new_password: '',
                new_password_confirmation: ''
            },
            pRules: {
                old_password: [{ required: true, validator: validatePass, trigger: 'blur' }],
                new_password: [{ required: true, validator: validatePass, trigger: 'blur' }],
                new_password_confirmation: [{ required: true, validator: pwdAgainCheck_p, trigger: 'blur' }]
            }
        }
    },
    methods: {
        showPwd() {
            if (this.pwdType === 'password') {
                this.pwdType = ''
            } else {
                this.pwdType = 'password'
            }
        },

        hancleChangeType(type) {
            this.$emit('hancleChange', type)
        },

        submit() {
            this.$refs['pForm'].validate((valid) => {
                if (valid) {
                    this.$emit('submit', this.pForm)
                }
            })
        }
    }
}
</script>

<style lang="less" scoped>
.m_container {
  width: 100vw;
  height: 100%;
  min-height: 100vh;
  background: #f5f5f5;

  .el-form{
    padding: 0;
    margin: 0 20px;

    .el-form-item{
      padding-left: 0;
    }

    .el-icon{
      display: inline-block;
      margin-top: 12px;
      margin-right: 8px;
      font-size: 16px;
    }

    .el-icon-view-actived{
      color: var(--color)
    }

    .form-item{
      display: flex;
      justify-content: space-between;
      align-items: center;

      .disabledBtn{
        background: #ccc;
        border-color: #ccc;
      }
    }
  }

  .title{
    padding: 50px 0;
    margin: 0 auto;
  }

  .textWrap{
    margin-top: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 12px;
    cursor: pointer;

    .register{
      color: var(--color);
      font-weight: bold;
    }

    p{
      padding: 0 10px;
    }
  }
}
</style>
